module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gauge-container"
  }, [_c('div', {
    staticClass: "gauge-image-container"
  }, [_c('img', {
    staticClass: "gauge",
    attrs: {
      "src": "/static/img/gauge.png",
      "alt": "gauge",
      "width": "78.9"
    }
  }), _vm._v(" "), _c('img', {
    ref: "needle",
    staticClass: "needle",
    style: (_vm.needleDeg),
    attrs: {
      "src": "/static/img/stick.png",
      "alt": "needle",
      "height": "34.6"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "ml-2 gauge-text"
  }, [_vm._v(_vm._s(_vm.percent) + " %")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ef3344e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/Gauge.vue
// module id = 1178
// module chunks = 33 34 45